// /auth/login page chrome — thinking/design/toile_surfaces/SignIn.dc.html
//
// The card carries its own lockup (mark 42 over the word 15), so unlike narcis's login page there
// is no stripped header above it: the page is the stage and the card sits alone on it.

.page {
    min-height: 100vh;
    background: var(--tl-stage);
    display: flex;
    flex-direction: column;
}

.main {
    flex: 1;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: min(22vh, 132px) 16px 64px;
}

@media (max-width: 600px) {
    .main {
        padding: 44px 16px 48px;
    }
}
